import { Configuration, PublicClientApplication } from '@azure/msal-browser'

const ua = window.navigator.userAgent
const msie = ua.indexOf('MSIE ')
const msie11 = ua.indexOf('Trident/')
const msedge = ua.indexOf('Edge/')
const firefox = ua.indexOf('Firefox')
const isIE = msie > 0 || msie11 > 0
const isEdge = msedge > 0
const isFirefox = firefox > 0

export const requestScopes = ['openid', 'fd1442d1-cbcc-4b73-a893-a61b8d3d4782']

export const msalConfig: Configuration = {
  auth: {
    clientId: 'fd1442d1-cbcc-4b73-a893-a61b8d3d4782',
    authority: 'https://sistemiv.b2clogin.com/sistemiv.onmicrosoft.com/B2C_1_SIGN_UP_AND_SIGN_IN',
    redirectUri: '/',
    postLogoutRedirectUri: '/',
    knownAuthorities: ['sistemiv.b2clogin.com'],
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: isIE || isEdge || isFirefox,
  },
  system: {
    allowRedirectInIframe: true,
  },
}

export const msalInstance = new PublicClientApplication(msalConfig)
